// THE LONGEST EACH TEXT BOX TAKES (TW-0275, 2026-10-14).
//
// One number per box, and it lives ONCE, at the repo root (form-field-limits.json): every box here draws it as its
// maxLength, and the API's signing door refuses a longer value in a sentence naming the box and the number
// (services/waiver-api/consolidated_api/form_fields.py, FORM_FIELD_TOO_LONG). So a client's own typing never reaches that
// refusal, because the box stops first; it is for a body a script posts, which since TW-0270's wrap could put megabytes of
// description onto thousands of pages of paper. This copy is generated: edit the root, cp it here and beside the door, and a
// test on each side fails while a copy has drifted.
//
// The numbers hold the longest real answer typed at a counter, with room, and are what the box already had wherever it had
// one (the details boxes' 70, who to call, the physician, the guardian, the cosmetic placement's 120). The health boxes moved
// on purpose since (TW-0502, 2026-10-26): the medical history, the medications and every box a yes opens take 500, a client's
// whole history, where 70 stopped twelve histories in the form audit's 48 days, and they grow with their text
// (growWithText.ts). A number box (the three of the birth date) and the date box take no maxLength in a browser, so none is
// drawn on them (NO_MAXLENGTH_IN_A_BROWSER) and theirs are set far beyond anything those boxes hold. The age is no box since
// TW-0503 (2026-10-29): the page reads it off the birth date, and the door writes it itself.
import limits from "./form-field-limits.json";

export type LimitedField = keyof typeof limits.limits;

/** Every limited box, by the name it posts under, and its length. */
export const FIELD_LIMITS: Record<LimitedField, number> = limits.limits;

/** The boxes a browser draws no maxLength on (type="number" and type="date"): the door's number still holds for them. */
export const NO_MAXLENGTH_IN_A_BROWSER: readonly LimitedField[] = ["birthDateMonth", "birthDateDay", "birthDateYear", "signedDate"];
